module.exports = __webpack_public_path__ + "img/trial4-2.9494f9d1.png";